module.exports = __webpack_public_path__ + "static/img/help11.d17944fe.png";